import { apiManager } from "../api-manager";

export const getStripeKeys = async () => {
  const res = await apiManager.get("/constants/get-stripe-secret-keys");
  return res;
};

export const getStripePaymentIntent = async ({
  userId,
  amount = 100, // TODO: change this to actual amount that would be calculated from calculateCost endpoint,
}: {
  userId: string;
  amount?: number;
}) => {
  const res = await apiManager.post("/stripe/payment-intent", {
    amount,
    userId,
  });
  return res;
};
